import { render } from "./insertSQM.vue?vue&type=template&id=f381b388&scoped=true"
import script from "./insertSQM.vue?vue&type=script&lang=js"
export * from "./insertSQM.vue?vue&type=script&lang=js"

import "./insertSQM.vue?vue&type=style&index=0&id=f381b388&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f381b388"]])

export default __exports__